import React, { useState, useEffect } from "react";
import "../../Styles/Employebenefits.css";
import { FaSearch } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../../nhrc_apis/ApiService";

const CATEGORY = "student";

function Studentsbenefits() {
  const [benefits, setBenefits]         = useState([]);
  const [search, setSearch]             = useState("");
  const [showPopup, setShowPopup]       = useState(false);
  const [editIndex, setEditIndex]       = useState(null);
  const [loading, setLoading]           = useState(false);
  const [pageLoading, setPageLoading]   = useState(true);
  const [inputContent, setInputContent] = useState("");

  useEffect(() => { fetchBenefits(); }, []);

  const fetchBenefits = async () => {
    try {
      setPageLoading(true);
      const response = await ApiService.AdminAPI.getAllBenefits(CATEGORY);
      const data = response.data;
      const normalized = Array.isArray(data) ? data : data?.benefits || data?.content || [];
      const mapped = normalized.map((item) => ({
        id:       item.id || item._id,
        category: item.category,
        cont:     item.content,
        status:   item.status || "active",
        selected: false,
      }));
      setBenefits(mapped);
    } catch (err) {
      console.error("Fetch benefits error:", err);
      toast.error("Failed to load student benefits!");
    } finally {
      setPageLoading(false);
    }
  };

  const openPopup = (index = null) => {
    setEditIndex(index);
    setInputContent(index !== null ? benefits[index].cont : "");
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setInputContent("");
    setEditIndex(null);
  };

  const handleSave = async () => {
    if (inputContent.trim() === "") {
      toast.error("Content cannot be empty!");
      return;
    }
    const payload = { category: CATEGORY, content: inputContent.trim() };
    try {
      setLoading(true);
      if (editIndex !== null) {
        const benefitId = benefits[editIndex].id;
        await ApiService.AdminAPI.updateBenefit(benefitId, payload);
        const updated = [...benefits];
        updated[editIndex] = { ...updated[editIndex], cont: payload.content };
        setBenefits(updated);
        toast.success("Benefit updated successfully!");
      } else {
        const response = await ApiService.AdminAPI.createBenefit(payload);
        const newItem  = response.data;
        setBenefits([...benefits, {
          id:       newItem.id || newItem._id,
          category: newItem.category || CATEGORY,
          cont:     newItem.content  || payload.content,
          status:   newItem.status   || "active",
          selected: false,
        }]);
        toast.success("Benefit added successfully!");
      }
      closePopup();
    } catch (err) {
      console.error("Save benefit error:", err);
      const msg = err?.response?.data?.message || err?.response?.data?.detail;
      toast.error(msg || "Failed to save benefit. Try again!");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const selectedItems = benefits.filter((item) => item.selected);
    if (selectedItems.length === 0) {
      toast.error("No records selected to delete!");
      return;
    }
    try {
      setLoading(true);
      const ids = selectedItems.map((item) => item.id);
      await ApiService.AdminAPI.deleteMultipleBenefits(ids);
      setBenefits(benefits.filter((item) => !item.selected));
      toast.success("Selected benefits deleted!");
    } catch (err) {
      console.error("Delete benefit error:", err);
      toast.error("Failed to delete. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIXED — uses actual index from benefits array
  const handleStatusChange = async (actualIndex, status) => {
    try {
      const benefitId = benefits[actualIndex].id;
      await ApiService.AdminAPI.updateBenefitStatus(benefitId, status);
      const updated = [...benefits];
      updated[actualIndex].status = status;
      setBenefits(updated);
      toast.success(`Status updated to ${status}!`);
    } catch (err) {
      console.error("Status update error:", err);
      toast.error("Failed to update status!");
    }
  };

  const toggleSelect = (actualIndex) => {
    const updated = [...benefits];
    updated[actualIndex].selected = !updated[actualIndex].selected;
    setBenefits(updated);
  };

  const toggleSelectAll = (e) => {
    const updated = benefits.map((item) => ({ ...item, selected: e.target.checked }));
    setBenefits(updated);
  };

  const filtered = benefits.filter((b) =>
    b.cont.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="empben-main-cont">
      <ToastContainer autoClose={2000} position="top-right" theme="colored" />

      <div className="empben-head-bar">
        <h2>Student Benefits</h2>
      </div>

      <div className="empben-action-bar">
        <div className="empben-search-box">
          <FaSearch className="empben-search-icon" />
          <input
            type="text"
            placeholder="Search by content..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button className="empben-show-btn" onClick={() => openPopup()}>ADD</button>
        <button className="empben-delete-btn" onClick={handleDelete} disabled={loading}>Delete</button>
      </div>

      <div className="empben-table-container">
        {pageLoading ? (
          <p style={{ textAlign: "center", padding: "20px" }}>Loading benefits...</p>
        ) : (
          <table className="empben-table">
            <thead>
              <tr>
                <th><input type="checkbox" onChange={toggleSelectAll} /></th>
                <th>Content</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
                    No student benefits found.
                  </td>
                </tr>
              ) : (
                // ✅ FIXED — actualIndex from benefits array, not filtered array
                filtered.map((co) => {
                  const actualIndex = benefits.findIndex((b) => b.id === co.id);
                  return (
                    <tr key={co.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={co.selected || false}
                          onChange={() => toggleSelect(actualIndex)}
                        />
                      </td>
                      <td>{co.cont}</td>
                      <td>
                        <button
                          className={`empben-active-btn ${co.status === "active" ? "" : "blur-btn"}`}
                          onClick={() => handleStatusChange(actualIndex, "active")}
                        >
                          Active
                        </button>
                      </td>
                      <td>
                        <button
                          className={`empben-inactive-btn ${co.status === "inactive" ? "" : "blur-btn"}`}
                          onClick={() => handleStatusChange(actualIndex, "inactive")}
                        >
                          In Active
                        </button>
                      </td>
                      <td>
                        <button className="empben-edit-btn" onClick={() => openPopup(actualIndex)}>
                          Edit
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </div>

      {showPopup && (
        <div className="empben-popup-bg">
          <div className="empben-popup">
            <h3>{editIndex !== null ? "Edit Benefit" : "Add Benefit"}</h3>

            <label className="empben-popup-label">Category</label>
            <input
              type="text"
              value="student"
              readOnly
              className="empben-popup-input"
              style={{ background: "#f0f0f0", cursor: "not-allowed" }}
            />

            <label className="empben-popup-label">Content *</label>
            <input
              type="text"
              placeholder="Enter benefit content..."
              value={inputContent}
              onChange={(e) => setInputContent(e.target.value)}
              className="empben-popup-input"
            />

            <div className="empben-popup-btn-cont">
              <button onClick={handleSave} className="empben-save-btn" disabled={loading}>
                {loading ? "Saving..." : editIndex !== null ? "Update" : "Add"}
              </button>
              <button onClick={closePopup} className="empben-cancel-btn">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Studentsbenefits;